import { FC } from "react";
import { Box, Text } from "@mantine/core";
import { useDebouncedCurrentGame } from "../../../../../hooks/useDebouncedCurrentGame";
import { DisplayGame } from "./DisplayGame";
import { DisplayShootout } from "./DisplayShootout";
import { useFullscreen } from "@mantine/hooks";
import { DimSpot } from "../2x1920x144/Display";

interface DisplayProps {
  competitionId?: string;
  text?: string;
  disabled?: boolean;
  dimSpot?: DimSpot | null;
  onDimSpotClick?: (spot: DimSpot) => void;
}

const DIM_SPOT_RADIUS = 60;

const DisplayText: FC<{ text: string }> = (props) => (
  <Text
    size="50px"
    ta="center"
    style={{
      lineHeight: "54px",
      fontFamily: "Chivo Mono",
      padding: 15,
      height: "100%",
    }}
  >
    {props.text}
  </Text>
);

export const Display: FC<DisplayProps> = (props) => {
  const { competitionId, text, disabled, dimSpot, onDimSpotClick } = props;
  const { fullscreen } = useFullscreen();

  const currentGameData = useDebouncedCurrentGame(competitionId, 10 * 1000);

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!onDimSpotClick) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width;
    const y = (e.clientY - rect.top) / rect.height;
    onDimSpotClick({ x, y });
  };

  return (
    <Box
      onClick={handleClick}
      style={{
        backgroundColor: "black",
        height: 190,
        width: 1024,
        color: "white",
        alignContent: "center",
        fontFamily: "Chivo Mono",
        position: fullscreen ? "absolute" : "relative",
        left: fullscreen ? 0 : undefined,
        top: fullscreen ? 0 : undefined,
        zIndex: 1000,
        cursor: onDimSpotClick ? "crosshair" : undefined,
      }}
    >
      {dimSpot && (
        <div
          style={{
            position: "absolute",
            left: `calc(${String(dimSpot.x * 100)}% - ${String(DIM_SPOT_RADIUS)}px)`,
            top: `calc(${String(dimSpot.y * 100)}% - ${String(DIM_SPOT_RADIUS)}px)`,
            width: DIM_SPOT_RADIUS * 2,
            height: DIM_SPOT_RADIUS * 2,
            borderRadius: "50%",
            backgroundColor: "black",
            zIndex: 2000,
            pointerEvents: "none",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: 0,
              height: 0,
              borderLeft: "8px solid transparent",
              borderRight: "8px solid transparent",
              borderBottom: "8px solid #1a1a1a",
            }}
          />
        </div>
      )}
      {!disabled && (
        <>
          {text && <DisplayText text={text} />}
          {!text && currentGameData.isSuccess && (
            <>
              {currentGameData.data.shootOutStarted ? (
                <DisplayShootout gameId={currentGameData.data.id} />
              ) : (
                <DisplayGame gameId={currentGameData.data.id} />
              )}
            </>
          )}
        </>
      )}
    </Box>
  );
};
